import axios from "axios";
import { useUser } from "../../Hooks/useUser";
const ClaimMontageViewModel = () => {
  const { REACT_APP_AWS_SERVERLESS } = process.env;
  const token = localStorage.getItem("token");
  const { allstarUser } = useUser();
  const headers = { Authorization: `Bearer ${allstarUser.token}` };

  const getClaimSquadMontage = async (clipId: string) => {
    const path = `${REACT_APP_AWS_SERVERLESS}/webhook/claim-squad-montage?clip=${clipId}&token=${token}`;

    const response = await axios({
      method: "GET",
      url: path,
    });

    return response.data;
  };

  const postClaimSquadMontage = async (clipId: string) => {
    const path = `${REACT_APP_AWS_SERVERLESS}/webhook/claim-squad-montage?token=${token}`;

    const response = await axios({
      method: "POST",
      url: path,
      headers,
      data: {
        clip: clipId,
      },
    });

    return response.data;
  };

  return {
    getClaimSquadMontage,
    postClaimSquadMontage,
  };
};

export { ClaimMontageViewModel };
